import { resolveBrand, isBrandedNarrow } from "../lib/brand";

/**
 * Brand Logo Component — swaps asset by host so soulumo.app renders
 * the Soulumo mark and never leaks the Reclaim wordmark.
 */

const sizeClasses = {
  sm: "h-6",      // 24px
  md: "h-8",      // 32px
  lg: "h-12",     // 48px
  xl: "h-16",     // 64px
};

const BRAND_LOGO = {
  soulumo: { src: "/brand-icons/soulumo-512.png", alt: "Soulumo" },
  oml:     { src: "/brand-icons/oml-512.png",     alt: "One Million Lights" },
};

export const Logo = ({
  variant = "dark",
  size = "md",
  className = "",
}) => {
  const brand = resolveBrand();
  const narrow = isBrandedNarrow(brand);
  const asset = narrow ? (BRAND_LOGO[brand] || BRAND_LOGO.soulumo)
    : { src: "/assets/reclaim-logo-white.png", alt: "Reclaim" };

  // For light backgrounds, invert the white logo (makes it dark/ash).
  // Branded icon assets are full-colour, so no filter.
  const filterClass = (!narrow && variant === "dark")
    ? "brightness-0 opacity-80"
    : "";

  return (
    <img
      src={asset.src}
      alt={asset.alt}
      className={`${sizeClasses[size]} w-auto object-contain ${filterClass} ${className}`}
      data-testid={`${narrow ? brand : "reclaim"}-logo`}
    />
  );
};

// Named export for flexibility
export default Logo;
